import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { authAPI } from '../services/api';
import {
  publicBodyFontFamily,
  publicHeadingFontFamily,
  publicPrimaryButtonSx,
  publicTextFieldSx,
} from '../components/common/PublicPageFrame';

function PlayStationClaimPage() {
  const location = useLocation();
  const [form, setForm] = useState({
    code: new URLSearchParams(location.search).get('code') || '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const update = (field) => (event) => setForm(current => ({ ...current, [field]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      const response = await authAPI.claimPsnWebAccess({ code: form.code, email: form.email, password: form.password });
      setMessage(response.data?.message || 'Browser access configured. Check your email.');
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Unable to configure browser access.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 5, md: 9 } }}>
      <Box sx={{ p: { xs: 3, md: 5 }, borderRadius: '28px', border: '1px solid rgba(19,61,103,0.12)', bgcolor: '#fff', boxShadow: '0 28px 72px rgba(18,61,103,0.10)' }}>
        <Stack spacing={2.4}>
          <Box>
            <Typography sx={{ fontFamily: publicHeadingFontFamily, fontSize: { xs: '2rem', md: '2.5rem' }, lineHeight: 1.05 }}>
              Set up browser access
            </Typography>
            <Typography sx={{ mt: 1.2, color: 'text.secondary', lineHeight: 1.7, fontFamily: publicBodyFontFamily }}>
              Use the claim code shown on PS5 to add an email and password to an automatically created Virtual Medic account.
            </Typography>
          </Box>
          {message ? <Alert severity="success">{message}</Alert> : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
          {!message ? (
            <Box component="form" onSubmit={submit}>
              <Stack spacing={2}>
                <TextField required label="Claim code" value={form.code} onChange={update('code')} sx={publicTextFieldSx} />
                <TextField required type="email" label="Email" value={form.email} onChange={update('email')} sx={publicTextFieldSx} />
                <TextField required type="password" label="Password" value={form.password} onChange={update('password')} helperText="At least 8 characters" sx={publicTextFieldSx} />
                <TextField required type="password" label="Confirm password" value={form.confirmPassword} onChange={update('confirmPassword')} sx={publicTextFieldSx} />
                <Button type="submit" disabled={submitting || form.password.length < 8} sx={{ ...publicPrimaryButtonSx, minHeight: 50 }}>
                  {submitting ? 'Saving...' : 'Configure browser access'}
                </Button>
              </Stack>
            </Box>
          ) : null}
        </Stack>
      </Box>
    </Container>
  );
}

export default PlayStationClaimPage;
